<template>
  <div class="Footer">
    <div class="Footer__left">
      <a :href="trans('bottom.term.url')" target="_blank">{{ trans('bottom.term.text') }}</a>
      <a :href="trans('bottom.cookie.url')" target="_blank">{{ trans('bottom.cookie.text') }}</a>
    </div>
    <div class="Footer__right">
      <a :href="trans('bottom.privacy.url')" target="_blank">{{ trans('bottom.privacy.text') }}</a>
      <a :href="trans('bottom.access.url')" target="_blank">{{ trans('bottom.access.text') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  translations: {
    fr: {
      bottom: {
        term: { text: 'Conditions générales', url: 'https://www.cirquedusoleil.com/fr/legal/corporate/termes-et-conditions' },
        cookie: { text: 'Politique sur les témoins', url: 'https://www.cirquedusoleil.com/fr/legal/corporate/politique-temoins' },
        privacy: { text: 'Politique de confidentialité', url: 'https://www.cirquedusoleil.com/fr/legal/corporate/politique-confidentialite' },
        access: { text: 'Accessibilité', url: 'https://www.cirquedusoleil.com/fr/legal/corporate/accessibility' },
      }
    },
    en: {
      bottom: {
        term: { text: 'Terms and conditions', url: 'https://www.cirquedusoleil.com/legal/corporate/terms-conditions' },
        cookie: { text: 'Cookie Policy', url: 'https://www.cirquedusoleil.com/legal/corporate/cookie-policy' },
        privacy: { text: 'Privacy Policy', url: 'https://www.cirquedusoleil.com/legal/corporate/privacy-policy' },
        access: { text: 'Accessibility', url: 'https://www.cirquedusoleil.com/legal/corporate/accessibility' },
      }
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Footer
  padding 20px 20px 50px
  display flex
  font-size 11px
  justify-content space-between
  position relative
  margin-top 20px
  &__left
  &__right
    width 50%
    position relative
  a
    text-decoration none
    display block
    margin-bottom 20px
    color #D2D2D2
</style>
